import React from 'react'
import { cn } from '@/lib/utils'
import { Card, CardContent } from '@/shared/ui'
import { PostContent } from './PostContent'
import { PostAttachments, type LightboxVariant } from './PostAttachments'
import type { PostAttachment } from '../types'
import {
  buildLinkPreview,
  extractFirstUrlFromHtml,
} from '@/modules/comunidade/services/linkPreviewService'
import { CommunityLinkPreviewCard } from '@/modules/comunidade/components/CommunityLinkPreviewCard'

type PostPreviewCardProps = {
  title: string
  contentHtml: string
  attachments: PostAttachment[]
  lightboxVariant?: LightboxVariant
  footer?: React.ReactNode
  className?: string
}

export function PostPreviewCard({
  title,
  contentHtml,
  attachments,
  lightboxVariant,
  footer,
  className,
}: PostPreviewCardProps) {
  const linkPreview = React.useMemo(() => {
    const url = extractFirstUrlFromHtml(String(contentHtml || ''))
    if (!url) return null
    return buildLinkPreview(url)
  }, [contentHtml])

  return (
    <Card className={cn(className)}>
      <CardContent className="p-4">
        <div className="text-base font-semibold leading-tight text-foreground">
          {title}
        </div>

        <div className="mt-3 min-w-0 space-y-3">
          <PostContent html={contentHtml} />

          <PostAttachments attachments={attachments} lightboxVariant={lightboxVariant} />

          {linkPreview && (
            <div>
              <CommunityLinkPreviewCard preview={linkPreview} />
            </div>
          )}

          {footer ? <div>{footer}</div> : null}
        </div>
      </CardContent>
    </Card>
  )
}
